<template>
    <div id="niceAndNeat">
        <div id="contractOveriew" class="row">
            <div class="e-card">
                <div class="row">
                    <div id="contractInfo" class="col-lg-8" style="padding: 2%;">
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='clientName' name="clientName" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.clientName" placeholder="Client Name"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id='startDate' name="startDate" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.startDate" placeholder="Start Date" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='country' name="country" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.country" placeholder="Country"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id='endDate' name="endDate" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.endDate" placeholder="End Date" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='companyName' name="companyName" :disabled="true" width="80%" floatLabelType="Auto" v-model="companyName" placeholder="Company"  @change="checkFields"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-dropdownlist id='strategy' name="strategy" :enabled='strategyDisabled' width="80%" floatLabelType="Auto" v-model="data.strategy" :fields="{text: 'name', value: 'id' }" :dataSource='strategys' placeholder="Strategy"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='utility' name="utility" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.utility" placeholder="Utility"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id='signedDate' name="signedDate" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.signedDate" placeholder="Strategy Signed Date" format="dd/MM/yyyy"></ejs-datepicker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='riskManager' name="riskManager" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.riskManager" placeholder="Risk Manager"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='strategyType' name="strategyType" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.strategyType" placeholder="Strategy Type"></ejs-textbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='supplier' name="supplier" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.supplier" placeholder="Supplier"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='alerts' name="alerts" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.alerts" placeholder="Alerts"></ejs-textbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='annualVolume' name="annualVolume" :disabled="true" width="80%" floatLabelType="Auto" v-model="annualVolume" placeholder="Annual Volume" format="n3"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSectionPosition">
                                <ejs-textbox id='pricingAreaNames' name="pricingAreaNames" :disabled="true" width="80%"  floatLabelType="Auto" v-model='pricingAreaNames' placeholder="Price Areas"></ejs-textbox>
                            </div>
                        </div>
                    </div>
                    <div id="buttons" class="col-lg-4 pt-5">
                        <div class="form-row">
                            <div class="col mt-5 mb-2 d-flex justify-content-center">
                                <ejs-button cssClass="e-primary" v-on:click.native='btnDownloadFullReport'>Full Position Report</ejs-button>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col mt-3 mb-4 d-flex justify-content-center">
                                <ejs-button cssClass="e-primary" v-on:click.native='btnDownloadPositionReport'>Position Summary</ejs-button>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col mt-5 mb-2 pt-5 d-flex justify-content-center">
                                <ejs-dropdownbutton ref="btnViewContracts" name="btnViewContracts" :disabled="true" id="btnViewContracts" cssClass="alfa-light-purple" :items='contractFileitems' :select="onViewContractClick">View Contracts</ejs-dropdownbutton>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col mt-3 d-flex justify-content-center">
                                <ejs-dropdownbutton ref="btnViewStrategy" name="btnViewStrategy" id="btnViewStrategy" :disabled="true" cssClass="alfa-light-purple" :items='contractStrategyFileItems' :select='onViewStrategyClick'>View Strategy</ejs-dropdownbutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="PositionData" class="row">
            <div class="e-card mt-2">
                <div class="form-group">
                    <div class="col-sm-3 m-2 d-flex">
                        <ejs-dropdownlist id="dplReportingView" name="dplReportingView" ref="reportingView" width="68%" :dataSource='reportingView' :fields="{text: 'name', value: 'id' }" :select='onReportViewSelect' placeholder="Reporting View" floatLabelType='Auto'></ejs-dropdownlist>
                        
                    </div>
                    <div class="col-sm-3 m-2 d-flex">
                        <ejs-dropdownlist ref='dplCurrency' id="currency" name="currency" style="width: 100%;" v-model="data.currencyId" :change="onCurrencyChange" :dataSource='currencies' :fields="{ text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :showClearButton='true'></ejs-dropdownlist>
                        <ejs-checkbox cssClass="postionCheck check-d" :change="onCheckPostionDefault" label='Default Mechanism' id="positionSummaryCheck" name="checkName" floatLabelType='Auto'></ejs-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col m-3">
                        <ejs-grid ref='grid'
                                  :dataSource='gridData'
                                  :allowPaging='false'
                                  :allowResizing='true'
                                  :allowReordering='false'
                                  :allowSorting='false'
                                  :autoFit='false'
                                  :queryCellInfo='customiseCell'>
                            <e-columns>
                                <e-column field='yearName' headerText='Year' width=120></e-column>
                                <e-column field='totalContractedVolumeInContractTradingUnit' headerText='Total Contracted Volume' format="n2"></e-column>
                                <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                                <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                                <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                                <e-column field='Reference' :columns='referenceColumns' textAlign="Center"></e-column>
                                <e-column field='Variance to Reference' :columns='varianceColumns' textAlign="Center"></e-column>
                                <e-column field='YoY' :columns='YoYColumns' textAlign="Center"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
        <div id="additionalComponents">
            <div id="positionSpinner"></div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import router from '../../router/index';
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
    import SyncHelper from '../../common/syncfusion';

    Vue.use(DatePickerPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(DropDownButtonPlugin);
    Vue.use(CheckBoxPlugin);

    export default {
        name: 'PositionSummaryReport',
        created() {
        },
        data() {
            return {
                data: {},
                unit: null,
                currency: null,
                currencyId: null,
                value: null,
                companyName: null,
                firstIndexCurrency: 3,
                strategyDisabled: false,
                target: '#target',
                width: '250px',
                header: 'Dialog',
                visible: false,
                contractFileitems: [],
                contractStrategyFileItems: [],
                strategyFileUrls: [],
                strategyList: [],
                strategyFileUrl: "",
                gridData: {},
                annualVolume: "",
                pricingAreaNames: "",
                showPriceAreaSectionPosition: false,
                filterOptions: gridOptions.filterSettings,
                pageSettings: gridOptions.pageSettings,
                reportingView: [{ "name": "CAL", "id": 1 }, { "name": "FIY", "id": 2 }, { "name": "12M", "id": 3 }],
                strategys: [{ "name": "Yes", "id": true }, { "name": "No", "id": false }],
                fixedColumns: [
                    {
                        field: 'fixedVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'fixedPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                openColumns: [
                    {
                        field: 'openVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'openPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                m2mColumns: [
                    {
                        field: 'm2mPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'm2mValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                referenceColumns: [
                    {
                        field: 'referencePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'referenceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                varianceColumns: [
                    {
                        field: 'variancePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'varianceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                YoYColumns: [
                    {
                        field: 'yoyDifferencePrice',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    },
                    {
                        field: 'yoyDifferencePercentage',
                        headerText: '%',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    }
                ],

            }
        },
        computed: {
            currencies() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?contractId=" + store.state.reportContractId);
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('positionSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('positionSpinner'));
            showSpinner(document.getElementById('mainSpinner'));
            this.$refs.reportingView.ej2Instances.value = 1;
            this.getPositionData("CAL");
            this.getContractData();
        },
        methods: {
            btnDownloadFullReport: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                /*this.currencySymbol = document.getElementById('currency').value.split(' - ')[0];*/
                let currencyId = this.currencyId;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateFullContractReport/${store.state.reportContractId}?currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('positionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('positionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            },
            onCheckPostionDefault: function (args) {
             
                store.state.isCheckDefaultM = args.checked;
                //let m = document.getElementsByName('checkName');

                //for (var i = 0; i < m.length; i++) {
 
                //    m[i].ej2_instances[0].checked = args.checked;
                       
               
               /// }
                let selected = document.getElementById('dplReportingView').value;
                this.currencyId = this.$refs.dplCurrency.ej2Instances.value;

                this.getPositionData(selected, this.currencyId);
            },
            onCurrencyChange: function (args) {
                if (args.isInteracted == true) {
                    this.currencyId = args.itemData.currencyId;

                    let selected = document.getElementById('dplReportingView').value;
                    this.getPositionData(selected, this.currencyId);
                }


            },
            btnDownloadPositionReport: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                let currencyId = this.$refs.dplCurrency.ej2Instances.value;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generatePositionReportPage/${store.state.reportContractId}?currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('positionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('positionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            //this is for contract files, if it is pdf it will continue on pdf viewer, or non pdf
            //it will download file
            onViewContractClick: function (e) {

                var item = e.element.textContent.split(".");
                var pdfFile = "";
                for (var i = 0; i < item.length; i++) {
                    if (item[i] == "pdf") {
                        pdfFile = item[i];
                    }
                }
                showSpinner(document.getElementById('mainSpinner'));
                showSpinner(document.getElementById('positionSpinner'));
                if (pdfFile == "pdf") {
                    var filePdf = this.getContractStrategyUrlPdf(e.element.id);
                    var contractName = document.getElementById('headerContract');
                    router.push({ name: "PDFViewer", params: { fileName: filePdf[0].id, contract: contractName.textContent } });
                } else {
                    const link = document.createElement('a');
                    link.href = e.element.id;
                    link.click();
                }
                hideSpinner(document.getElementById('positionSpinner'));
                hideSpinner(document.getElementById('mainSpinner'));

            },
            //this is for strategy files, if it is pdf it will continue on pdf viewer, or non pdf
            //it will download file
            onViewStrategyClick: function (e) {
                var item = e.element.textContent.split(".");
                var pdfFile = "";
                for (var i = 0; i < item.length; i++) {
                    if (item[i] == "pdf") {
                        pdfFile = item[i];
                    }
                }
                showSpinner(document.getElementById('positionSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                if (pdfFile == "pdf") {
                    var filePdf = this.getContractStrategyUrlPdf(e.element.id);
                    var contractName = document.getElementById('headerContract');
                    router.push({ name: "PDFViewer", params: { fileName: filePdf[0].id, contract: contractName.textContent } });
                } else {

                    const link = document.createElement('a');
                    link.href = e.element.id;
                    link.click();
                }
                hideSpinner(document.getElementById('positionSpinner'));
                hideSpinner(document.getElementById('mainSpinner'));
            },
            getContractData() {
                apis.protectedApi(`contract/overview?contractId=${store.state.reportContractId}`)
                    .then(response => {
                        if (response.data) {
                            this.showPriceAreaSectionPosition = response.data.pricingAreaNames != "" ? true : false;
                            this.pricingAreaNames = response.data.pricingAreaNames;
                            if (response.data.pricingAreaNames != "") {
                                store.state.pricingAreaNames = response.data.pricingAreaNames;
                            } else {
                                store.state.pricingAreaNames = undefined;
                            }

                            if (response.data.contractFileUrls) {
                                this.$refs.btnViewContracts.ej2Instances.disabled = false;
                                this.contractFileitems = this.getContractStrategyUrl(response.data.contractFileUrls);

                            } else {
                                this.$refs.btnViewContracts.ej2Instances.disabled = true;
                            }
                            if (response.data.strategyFileUrl) {

                                this.$refs.btnViewStrategy.ej2Instances.disabled = false;
                                this.contractStrategyFileItems = this.getContractStrategyUrl(response.data.strategyFileUrl);
                            } else {
                                this.$refs.btnViewStrategy.ej2Instances.disabled = true;
                            }
                        }
                    }).catch(e => {
                        this.showErrorDialog("Something went wrong, please contact support.");
                        hideSpinner(document.getElementById('mainSpinner'));
                    });
            },
            //this method is for contract file and strategy
            //this is for ono pdf files, non slice just simple all url link
            getContractStrategyUrl: function (strategyFileUrls) {

                var items = [];
                let input = strategyFileUrls ? strategyFileUrls.split(",") : [];
                for (let index in input) {
                    items.push({ text: input[index].split(/[\s/]+/).pop(), id: input[index] });
                }
                return items;
            },
            //this method is for contract file and strategy
            //this is for  pdf files, slice and covnertig file for pdf viewer
            getContractStrategyUrlPdf: function (strategyFileUrls) {

                var items = [];
                let input = strategyFileUrls ? strategyFileUrls.split(",") : [];
                for (let index in input) {
                    items.push({ text: input[index].split(/[\s/]+/).pop().slice(0, -4), id: input[index].split(/[\s/]+/).pop() });
                }
                return items;
            },
            getPositionData: function (reportView, currencyId) {
                showSpinner(document.getElementById('mainSpinner'));
                /*apis.protectedApi(`report/positionsummary/${store.state.reportContractId}?reportView=${reportView}&currencySymbol=${currencySymbol == undefined ? "" : currencySymbol}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`)*/
                apis.protectedApi(`report/positionsummary/${store.state.reportContractId}?reportView=${reportView}&currencyId=${currencyId == undefined ? "" : currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`)
                    .then(response => {
                        const company = document.getElementById('companyName').value;
                        if (company != null && company != '') {
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                        hideSpinner(document.getElementById('positionSpinner'));
                        this.data = response.data.result;
                        this.unit = response.data.unit;
                        this.currency = response.data.currency;
                        this.value = response.data.value;
                        this.companyName = response.data.result.companyName;
                        this.gridData = response.data.result.calendarPositionData;
                        this.annualVolume = response.data.result.annualVolume.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + " " + response.data.unit;
                        if (response.data.value == 'p/therm') {

                            /*this.$refs.dplCurrency.ej2Instances.value = "p";*/
                            this.$refs.dplCurrency.ej2Instances.text = "p - GBp";

                        } else {
                            this.$refs.dplCurrency.ej2Instances.text = response.data.currencySymbolAndName;
                        }

                    }).catch(e => {

                        hideSpinner(document.getElementById('mainSpinner'));
                        hideSpinner(document.getElementById('positionSpinner'));
                        if (e.response) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            onReportViewSelect: function (args) {
                let selected = args.itemData.name;
                this.getPositionData(selected);
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            customiseCell: function (args) {
                if (args.column.field === 'totalContractedVolumeInContractTradingUnit' || args.column.field === 'openVolumeInContractTradingUnit') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.unit;
                } else if (args.column.field === 'fixedVolumePercentage' || args.column.field === 'openVolumePercentage') {
                    args.cell.textContent = args.cell.textContent + ' ' + "%";
                } else if (args.column.field === 'fixedPrice' || args.column.field === 'openPrice' || args.column.field === 'm2mPrice' || args.column.field === 'referencePrice' || args.column.field === 'variancePrice') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.value;
                } else if (args.column.field === 'referenceValue' || args.column.field === 'openValue' || args.column.field === 'm2mValue' || args.column.field === 'fixedValue' || args.column.field === 'yoyDifferencePrice' || args.column.field === 'varianceValue') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                }
            },
            checkFields() {
                const company = document.getElementById('companyName').value;
                if (company != null && company != '') {
                    hideSpinner(document.getElementById('mainSpinner'));
                } 
            }
        }
    }
</script>

<style>


    .volume-unit {
        width: 100%;
        padding-left: 5px;
    }
    .postionCheck {
        margin: 25px 0px 0px 5px !important;
        padding-right: 18px;
    }
    #positionSpinner {
        display: none;
    }
</style>
